import { storedFilterSelections } from '../dashboardTileFilters';

import type {
  DashboardUpdateRequest,
  DraftDashboardContent,
  DraftDashboardTile,
  HydratedDashboard,
} from './dashboard.types';

export function toDashboardContentPlacement(
  tile: DraftDashboardTile
): DraftDashboardContent {
  return {
    instanceId: tile.instanceId,
    contentId: tile.contentId,
    widthFactor: tile.widthFactor,
    ...storedFilterSelections(tile),
  };
}

export function projectDashboardUpdateRequest(
  dashboard: Pick<
    HydratedDashboard,
    'sourcePageId' | 'name' | 'description' | 'sharingStatus'
  >,
  tiles: readonly DraftDashboardTile[]
): DashboardUpdateRequest {
  return {
    sourcePageId: dashboard.sourcePageId,
    name: dashboard.name,
    description: dashboard.description ?? null,
    sharingStatus: dashboard.sharingStatus,
    contents: tiles.map(toDashboardContentPlacement),
  };
}

export function areDashboardUpdateRequestsEqual(
  a: DashboardUpdateRequest,
  b: DashboardUpdateRequest
): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
